// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalcFormInput_wrapper__KsLAz","button":"CalcFormInput_button__72Xcu","fieldError":"CalcFormInput_fieldError__Akj__"};